import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((_theme: Theme) => ({
  tabWrapper: {
    marginTop: '30px',
  },
}));

export default useStyles;
